import { useEffect, useMemo } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import config from 'config';
import mappers from '../../services/tracking/propertyMappers';
import { useSelector } from 'react-redux';
import { getSubscription, selectUser } from '../../reducers/user.selectors';
import useIntercom from '../../utils/useIntercom';
import { notifyBugsnagHandledError } from '../../utils/bugsnagClient';

const IntercomButton = () => {
  const user = useSelector(selectUser);
  const subscription = useSelector(getSubscription);
  const { isIntercomVisible } = useIntercom();

  const intercomUserData = useMemo(() => {
    const data = mappers.intercom(user, subscription);
    if (!data) return undefined;
    return { ...data, created_at: data.created_at ?? undefined };
  }, [user, subscription]);

  const intercomDataKey = useMemo(
    () => intercomUserData ? JSON.stringify(intercomUserData) : '',
    [intercomUserData]
  );

  useEffect(() => {
    if (!isIntercomVisible) return;

    try {
      Intercom({
        app_id: config.intercom.appId,
        region: config.intercom.region,
        ...intercomUserData
      });
    } catch (error) {
      notifyBugsnagHandledError(error as Error);
    }
  }, [isIntercomVisible, intercomDataKey]);

  return null;
};

export default IntercomButton;
